import { ActivityDetailHeaderSection } from 'modules';
import { SubscriptionActivityMultitab } from 'modules/components/layer52';



export const SubscriptionActivity = () => {

  return (
    <>
      <ActivityDetailHeaderSection.FC
        header='Subscription Settings'
        removeBackButton
      />

      <SubscriptionActivityMultitab.FC />
    </>
  );
};
